<template>
    <vs-button
        :class="{'w-full' : fullBtn, 'mr-2' : !fullBtn }"
        class="justify-end"
        type="relief"
        color="danger" 
        @click="cancelOrder()"
        @mouseenter="() => show.btnCancel = true"
        @mouseleave="() => show.btnCancel = false"
        > 
        <a-icon type="delete" style="font-size: 15px" /> 
        <template v-if="fullBtn">
            CANCELAR
        </template>
        <template v-else>
            {{ show.btnCancel ? 'Cancelar' : '' }}  
        </template>
         
    </vs-button>
    <!-- <vs-button class="w-full" type="border" @click="cancelOrder()">{{ $t('cancelOrder').toUpperCase() }}</vs-button> -->
</template>

<script>
    import { httpsCallable } from "@/firebase/functions";

    export default {
        props : {
            fullBtn : Boolean,
            billId : {
                type : String,
                required : true,
            },
        },

        data () {
            return {
                show : {
                    btnCancel : false
                }
            }
        },

        methods : {
            cancelOrder () {
                let that = this
                let companyId = this.$store.getters.getCompanyID

                this.$confirm({
                    zIndex : 999999,
                    title: this.$t('confirmYourIntention'),
                    content: this.$t('reallyRemoveBill'),
                    okText : this.$t('yesCancelBill'),
                    cancelText : this.$t('no'),
                    okType: 'danger',
                    async onOk () {
                        try {
                            that.$vs.loading()
                            let call = httpsCallable('cancelBill')
                            await call({ companyId : companyId, billId: that.billId })
                        } catch (err) {
                            that.$error({
                                zIndex : 999999,
                                title: that.$t('cancelError'),
                                content: `${that.$t('errorWhileCancelingBill')} ${err.message}`
                            })
                        } finally {
                            that.$vs.loading.close()
                        }
                    }
                })
            }
        }
    }
</script>